// Lot and margin parsing shared by the wizard and the quote detail.
// An empty field falls back to the default; "0" stays 0 (no `|| default`).
export const DEFAULT_MARGIN = 25;

export function parseMargin(value) {
  const n = parseFloat(value);
  return Number.isFinite(n) ? n : DEFAULT_MARGIN;
}

export function parseLot(value) {
  const n = parseInt(value, 10);
  return Number.isFinite(n) ? n : 1;
}

export function quoteParamsError(lot, margin, t) {
  if (parseLot(lot) < 1) return t("quoteParams.lotMin");
  if (parseMargin(margin) < 0) return t("quoteParams.marginMin");
  return "";
}
